// @flow
import api from 'common/services/api';
import DateRange from 'common/domain/DateRange';
import StreamData from '../domain/StreamMetrics';
import Stream from '../domain/Stream';
import StreamLiveMetrics from '../domain/StreamLiveMetrics';

class StreamingAPI {

  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token });

  async fetchMetrics(token: string, callSign: string, reference: string, period: DateRange): Promise<StreamData> {
    // const url = `/statsradio/${callSign}/streams/${reference}`;

    // const { data } = await api.get(url, period.toISO(), { headers: this.buildHeaders(token) });

    return StreamData.parse({ uniqueConnections: 412,
      peakConnections: 35,
      listeningTimeMinutes: 10,
      listeningTimeHours: 5,
      totalSessions: 100,
      dailyAverageSessions: 50,
      hourlyAverageSessions: 30,
      averageSessionDuration: 70,
    });
  }

  async fetchStreams(token: string, callSign: string): Promise<Stream> {
    const url = `/statsradio/${callSign}/streams`;

    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    return data.map(unparsed => Stream.parse(unparsed));
  }

  async fetchLiveMterics(token: string, callSign: string, streamReference: string): Promise<StreamLiveMetrics> {
    const url = `/statsradio/${callSign}/streams/${streamReference}/live-metrics`;

    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    return StreamLiveMetrics.parse(data);
  }
}

export default new StreamingAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/services/StreamingAPI.js